import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { LogoDataSchema } from '../../shared/logo.schema';
/**
 * Request Presigned URL Request Schema
 * POST /api/v2/upload-org-logo/request-url
 * Requests a presigned URL for direct upload to DigitalOcean Spaces
 */ export const OrgLogoRequestPresignedUrlRequestSchema = z.object({});
/**
 * Request Presigned URL Response Schema
 * Returns presigned POST URL and fields for direct upload
 */ export const OrgLogoRequestPresignedUrlResponseSchema = z.object({
    url: z.string(),
    fields: z.record(z.string(), z.string()),
    key: z.string(),
    expiresIn: z.number()
});
/**
 * Confirm Upload Request Schema
 * POST /api/v2/upload-org-logo/confirm
 * Confirms the upload and triggers processing
 */ export const OrgLogoConfirmUploadRequestSchema = z.object({
    key: z.string(),
    mimeType: z.string()
});
/**
 * Confirm Upload Response Schema
 * Returns processed logo URLs (SVG or Raster)
 */ export const OrgLogoConfirmUploadResponseSchema = z.object({
    logo: LogoDataSchema
});
/**
 * Upload Org Logo Error Schema
 */ export const UploadOrgLogoErrorSchema = BaseErrorSchema;

//# sourceMappingURL=upload-org-logo.schema.js.map